import React, { useEffect, useState } from 'react'
import DataTables from '../../Main/DataTable/DataTables'
import { getNewsletter } from '../../../Services/AdminServices/adminUserServices';

const Newsletter = () => {

    const columns = [
        { name: 'Email', selector: row => row.email },
    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const getAllNewsletter = async () => {
        setLoading(true)
        const response = await getNewsletter();
        if (response?.code === 200) {
            setData(response?.result?.newsletters?.original?.data)
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => { getAllNewsletter(); }, [])

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className='fw-bold mb-0'>Newsletter</h3>
                        <p className='text-muted'>Manage Newsletter</p>
                    </div>


                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="col-lg-12">
                            <DataTables filter={true} columns={columns} data={data} />
                        </div>
                    )}

                </div>
            </div>
        </>
    )
}

export default Newsletter